import state from '@/store/hoPaginatedList/state';

export default state;
